import { IdlePeriodLegacySettingsModel } from 'src/Libs/smart-charge/models'
import { IdlePeriodsLegacySettingsDto } from 'src/Libs/smart-charge/dto'

const fromDtoToModelTransformer = (dto: IdlePeriodsLegacySettingsDto): IdlePeriodLegacySettingsModel => ({
  emsIdlePeriod: dto.emsIdlePeriod || [],
})

export default fromDtoToModelTransformer
